import React, {useEffect, useState} from 'react';
import '../../assets/css/modal.css';

const VideoModal = ({ videoUrl, onClose }) => {
    const [loading, setLoading] = useState(true);
    return (
        <div className="modal-container pusher-notify-wrapper pusher-notification-modal">
            <div className="modal-content pusher-notification">
                <video controls>
                    <source src={videoUrl} type="video/mp4" />
                </video>
                <button className="notify-close-btn" onClick={onClose}>
                    &times;
                </button>
            </div>
        </div>
    );
};

export default VideoModal;
